<template lang="pug">
  v-app
    router-view
</template>

<script>
  export default {}
</script>


// WEBPACK FOOTER //
// src/App.vue